import type {ReactElement} from 'react';
import type {IconProps} from '@Components/icon-v2';
import type {TOOLTIP_POSITION} from '@Components/tooltip';

export interface Offset {
  x: number;
  y: number;
}

export enum TooltipPlacement {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}

export interface IconWithTooltipProps extends IconProps {
  toolTipHideDelay?: number;
  /** Plain-text tooltip body. Ignored when `tooltipContent` is provided. */
  tooltipText?: string;
  /**
   * Rich tooltip body (e.g. text with a hyperlink). Takes precedence over
   * `tooltipText` — the underlying react-bootstrap Tooltip renders any markup.
   */
  tooltipContent?: ReactElement;
  className?: string;
  /** Extra class on the tooltip bubble itself (not the icon) — e.g. to cap its width so it stays centered on the icon. */
  tooltipClassName?: string;
  offset?: Offset;
  /** When omitted, derived from `placement` (top→BOTTOM_MIDDLE, bottom→TOP_MIDDLE, left→BOTTOM_RIGHT, right→BOTTOM_LEFT). */
  arrowPosition?: TOOLTIP_POSITION;
  /**
   * Hides the speech-bubble arrow on the tooltip. Use when the trigger is much
   * narrower than the tooltip text and the arrow can't reliably point at the icon.
   */
  hideArrow?: boolean;
  /** Tooltip placement; use `BOTTOM` when the trigger has no headroom for an above-trigger tooltip. */
  placement?: TooltipPlacement;
}
